/**
 * Client-only UI chrome that should survive reload via vuex-persist.
 * Not a home for server-backed settings.
 *
 * TODO: fold admin-mode.js into this module as `adminModeEnabled`
 * (adminMode is already on the persist whitelist separately — consolidate when convenient).
 */

import {UPSTREAM_SOURCE_RECONCILIATION_MODES} from '@/util/refinery/upstream/constants'

function normalizeUpstreamSourceReconciliationMode(mode) {
  return mode === UPSTREAM_SOURCE_RECONCILIATION_MODES.SHIP
    ? UPSTREAM_SOURCE_RECONCILIATION_MODES.SHIP
    : UPSTREAM_SOURCE_RECONCILIATION_MODES.KEEP
}

const state = {
  upstream: {
    sourceReconciliationMode: UPSTREAM_SOURCE_RECONCILIATION_MODES.KEEP,
  },
}

const getters = {
  getUpstreamSourceReconciliationMode: (state) =>
    normalizeUpstreamSourceReconciliationMode(state.upstream?.sourceReconciliationMode),
}

const mutations = {
  SET_UPSTREAM_SOURCE_RECONCILIATION_MODE(state, mode) {
    state.upstream = {
      ...state.upstream,
      sourceReconciliationMode: normalizeUpstreamSourceReconciliationMode(mode),
    }
  },
}

const actions = {
  setUpstreamSourceReconciliationMode({commit}, mode) {
    commit('SET_UPSTREAM_SOURCE_RECONCILIATION_MODE', mode)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
